export const dummyProfilingData = [
  {
    assetName: 'customer_data.csv',
    columns: [
      {
        columnName: 'Name',
        businessTerm: 'Full name of the customer.',
        dataType: 'String',
        statistics: {
          avgLength: 17.9,
          maxLength: 40,
          minLength: 7,
        },
        nullPercentage: 0,
        uniquePercentage: 98,
        dataDistribution: [
          { label: 'A-E', value: 200 },
          { label: 'F-J', value: 450 },
          { label: 'K-O', value: 600 },
          { label: 'P-T', value: 300 },
          { label: 'U-Z', value: 500 },
        ],
      },
      {
        columnName: 'Email',
        businessTerm: '',
        dataType: 'String',
        statistics: {
          avgLength: 25.4,
          maxLength: 50,
          minLength: 15,
        },
        nullPercentage: 0,
        uniquePercentage: 100,
        dataDistribution: [
            { label: 'A-E', value: 150 },
            { label: 'F-J', value: 550 },
            { label: 'K-O', value: 700 },
            { label: 'P-T', value: 250 },
            { label: 'U-Z', value: 400 },
        ],
      },
    ],
  },
  {
    assetName: 'sales_transactions.parquet',
    columns: [
      {
        columnName: 'transaction_id',
        businessTerm: 'Primary key for sales transactions.',
        dataType: 'Integer',
        statistics: {
          avgLength: 8,
          maxLength: 8,
          minLength: 8,
        },
        nullPercentage: 0,
        uniquePercentage: 100,
         dataDistribution: [
            { label: '0-2k', value: 800 },
            { label: '2k-4k', value: 750 },
            { label: '4k-6k', value: 700 },
            { label: '6k-8k', value: 650 },
            { label: '8k-10k', value: 600 },
        ],
      },
      {
        columnName: 'sale_amount',
        businessTerm: '',
        dataType: 'Decimal',
        statistics: {
          avgLength: 5.2,
          maxLength: 10,
          minLength: 2,
        },
        nullPercentage: 1.2,
        uniquePercentage: 78,
         dataDistribution: [
            { label: '$0-50', value: 400 },
            { label: '$50-100', value: 800 },
            { label: '$100-150', value: 500 },
            { label: '$150-200', value: 300 },
            { label: '$200+', value: 100 },
        ],
      },
    ],
  },
];

// Dummy data for column selection step
export const dummyColumnSelectionData = [
  {
    name: 'customer_transactions',
    path: 'sales.transactions',
    source: 'adls',
    columns: [
      { id: 'customer_id', name: 'customer_id', type: 'varchar(50)' },
      { id: 'first_name', name: 'first_name', type: 'varchar(100)' },
      { id: 'last_name', name: 'last_name', type: 'varchar(100)' },
      { id: 'email', name: 'email', type: 'varchar(255)' },
      { id: 'phone_number', name: 'phone_number', type: 'varchar(20)' },
      { id: 'address', name: 'address', type: 'varchar(200)' },
      { id: 'city', name: 'city', type: 'varchar(100)' },
      { id: 'state', name: 'state', type: 'varchar(50)' },
      { id: 'zip_code', name: 'zip_code', type: 'varchar(20)' },
      { id: 'registration_date', name: 'registration_date', type: 'timestamp' },
    ]
  },
  {
    name: 'product_sales',
    path: 'sales.products',
    source: 'uc',
    columns: [
      { id: 'product_id', name: 'product_id', type: 'varchar(50)' },
      { id: 'product_name', name: 'product_name', type: 'varchar(100)' },
      { id: 'category', name: 'category', type: 'varchar(100)' },
      { id: 'price', name: 'price', type: 'decimal(10,2)' },
      { id: 'quantity', name: 'quantity', type: 'int' },
      { id: 'sale_date', name: 'sale_date', type: 'timestamp' },
    ]
  }
]; 